<template>

    <inertia-link :href="route('messages.show', message)" 
                  :id="'message-' + message.id"
                  class="list-group-item list-group-item-action py-3">
        <div class="row align-items-center">

            <div class="col-6">

                <div class="">
                    <div class="text-truncate mb-1" :class="{'fw-bold': message.recipient_id === $page.props.auth.user.account.id && message.read_at === null}">
                        <div class="spinner-grow spinner-grow-sm text-success"
                             role="status"
                             v-if="message.recipient_id === $page.props.auth.user.account.id && message.read_at === null">
                            <span class="visually-hidden">{{ __('New') }}</span>
                        </div>
                        {{ message.subject }}
                    </div>
                    <div class="small text-muted text-truncate">
                        {{ message.clean_text | truncateWords }}
                    </div>
                </div>

            </div>

            <div class="col-4">

                <template v-if="message.sender_id === $page.props.auth.user.account.id">
                    <div class="text-truncate">
                        <!--@todo Limit-->
                        <div v-for="recipient in message.recipients">
                            {{ recipient.name }}
                            <div class="small text-muted" v-if="recipient.email">
                                {{ recipient.email }}
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="text-truncate" v-if="message.author">
                        {{ message.author.full_name }}
                    </div>
                    <div class="small text-truncate" :title="message.sender.name" v-else>
                        {{ message.sender.name }}
                    </div>
                </template>

            </div>

            <div class="col-2">
                <div v-if="mode === 'trash'">
                    {{ message.deleted_at | localizeDateTime }}
                </div>
                <div v-else>
                    {{ message.created_at | localizeDateTime }}
                </div>
                <!--@todo <i class="bi bi-three-dots-vertical"></i>-->
            </div>

        </div>
    </inertia-link>

</template>

<script>
    export default {
        props: [
            'mode',
            'message',
        ],
        data() {
            return {}
        },
        mounted() {
        },
        components: {
        },
        methods: {
        },
    }
</script>

<style scoped>

</style>